import React, { useState, useEffect } from 'react';
import {
  Card,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { firestore } from '../../../../contexts/FirebaseContext';
import { filter } from 'lodash';
import { UserListHead, UserListToolbar } from '../../user/list';
import Label from '../../../Label';
import Scrollbar from '../../../Scrollbar';
import SearchNotFound from '../../../SearchNotFound';
// import { sentenceCase } from 'change-case';
import { useTheme } from '@mui/material/styles';
import { fCurrency } from '../../../../utils/formatNumber';
import { fDate, fDateTime } from '../../../../utils/formatTime';
import { startDate } from '../../../../constants/estartDate';
import { Icon } from '@iconify/react';
import UserBasicInfo from '../general/UserBasicInfo';
import ReportListToolbar from '../ReportListToolbar';
import ClipReembolsoListToolbar from './ClipReembolsoListToolbar';
import MenuOptions from './MenuOptions';
import MenuItems from './MenuItems';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '' },
  { id: 'licenciatario', label: 'Licenciatario', alignRight: false },
  { id: 'item', label: 'Item', alignRight: false },
  { id: 'date', label: 'Fecha', alignRight: false },
  { id: 'montoPagado', label: 'Monto', alignRight: false },
  { id: 'refernceCode', label: 'Referencia', alignRight: false },
  { id: 'servicio', label: 'Servicio', alignRight: false },
  { id: 'status', label: 'Estado' }
  //   { id: 'status', label: 'Status', alignRight: false },
  //   { id: 'isVerified', label: 'Verified', alignRight: false },
  //   { id: '' }
];

// UserItem.propTypes = {
//   user: PropTypes.object
// };

// function UserItem({ user }) {
//   return (
//     <TableRow>
//       <TableCell>{user.name}</TableCell>
//       <TableCell>{user.email}</TableCell>
//       <TableCell>{user.role}</TableCell>
//     </TableRow>
//   );
// }

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user?.folio?.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

// PaymentReports.propTypes = {
//   user: PropTypes.object
// };

export default function ClipReembolsosList({ dataList, isAdmin }) {
  const [reports, setReports] = useState([]);
  const [statusSelected, setStatusSelected] = useState(null);
  const theme = useTheme();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // console.log(reports);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = dataList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // const handleDeleteUser = (userId) => {
  //   console.log(userId);
  // };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filterStatus = (data, status) => {
    if (status === 'CANCELADO') {
      return data.filter((item) => item.status === status);
    }
    if (status === 'RECHAZADO') {
      return data.filter((item) => item.status === status);
    }
    if (status === 'PENDIENTE') {
      return data.filter((item) => item.status === status);
    }
    if (status === 'APLICADO') {
      return data.filter(
        (item) => item.status !== 'CANCELADO' && item.status !== 'PENDIENTE' && item.status !== 'RECHAZADO'
      );
    }
    return data;
  };

  // const filteredByStatus = statusSelected ? dataList.filter((item) => item.status === statusSelected) : dataList;
  const filteredByStatus = filterStatus(dataList, statusSelected);

  const filteredUsers = applySortFilter(filteredByStatus, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Card>
      <ClipReembolsoListToolbar
        numSelected={selected.length}
        filterName={filterName}
        onFilterName={handleFilterByName}
        handleStatus={setStatusSelected}
      />
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
              checkboxOption={false}
            />
            <TableBody>
              {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                // const { id, name, email, role, wallet, status = 'active' } = row;
                // dataList.map((row) => {
                const {
                  id,
                  created_at,
                  paidItems,
                  paidItemsData,
                  montoPagado,
                  servicio,
                  stauserToPaytus,
                  status,
                  userToPay,
                  referenceCode
                } = row;
                const isItemSelected = selected.indexOf(id) !== -1;

                let statusShow;
                if (status === 'PENDIENTE') {
                  statusShow = (
                    <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="info">
                      Pendiente
                    </Label>
                  );
                  // statusShow = <Chip sx={{ fontSize: '10px' }} label="Pendiente" size="small" color="info" />;
                } else if (status === 'RECHAZADO') {
                  statusShow = (
                    <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="error">
                      Rechazado
                    </Label>
                  );
                }
                // else if (status === 'CANCELADO') {
                //   statusShow = (
                //     <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="primary">
                //       Cancelado
                //     </Label>
                //   );
                // }
                else {
                  statusShow = (
                    <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="success">
                      Aplicado
                    </Label>
                  );
                }

                return (
                  <TableRow
                    hover
                    key={`id-${index}`}
                    tabIndex={-1}
                    role="checkbox"
                    selected={isItemSelected}
                    aria-checked={isItemSelected}
                  >
                    <TableCell padding="checkbox">
                      {isAdmin && <>{status === 'PENDIENTE' && <MenuOptions dataItem={row} />}</>}
                    </TableCell>
                    {/* <TableCell component="th" scope="row" padding="none">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Avatar alt={name} src={photoURL} />
                        <Typography variant="subtitle2" noWrap>
                          {name}
                        </Typography>
                      </Stack>
                    </TableCell> */}

                    <TableCell>
                      <UserBasicInfo user_id={userToPay} />
                    </TableCell>
                    <TableCell>
                      <MenuItems paidItemsData={paidItemsData} paidItems={paidItems} />
                    </TableCell>
                    {/* <TableCell align="left">{fDate(new Date(authorized_at?.seconds * 1000).toISOString())}</TableCell> */}
                    <TableCell align="left">{fDateTime(created_at.toDate())}</TableCell>
                    <TableCell align="left">{fCurrency(montoPagado)}</TableCell>
                    <TableCell align="left">{referenceCode}</TableCell>
                    <TableCell align="left">{servicio}</TableCell>
                    {/* <TableCell align="left">{fCurrency(amount)}</TableCell> */}
                    <TableCell>{status}</TableCell>

                    {/* <TableCell align="right">
                      <UserMoreMenu onDelete={() => handleDeleteUser(id)} userName={id} />
                    </TableCell> */}
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredUsers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Card>
  );
}
